import { defineMessage } from 'services/localization';

export const messages = {
    xeroSigninText: defineMessage('log_in_with'),
    googleSigninText: defineMessage('sign_in_with_google'),
    xeroSignupText: defineMessage('sign_up_with'),
    googleSignupText: defineMessage('sign_up_with_google'),
    generalErrorMessage: defineMessage('oops_something_went_wrong'),
};
